module.exports = __webpack_public_path__ + "img/bento_3000.b63e9099.png";